import React from 'react';
import { useNavigate } from "react-router-dom";
import { Typography, Button, Box, Alert, Grid } from "@mui/material";
import { useTranslation } from 'react-i18next';

function AccountCreated() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Box sx={{ textAlign: 'center', mt: 5, px: 2 , marginTop: '100px'}}>
            <Typography variant="h4" gutterBottom>
                {t('Administration.AccountCreatedTitle')} <br />
                {t('Administration.AccountCreatedMessage')}
            </Typography>

            <Button
                variant="contained"
                color="primary"
                sx={{ mt: 3 }}
                onClick={() => navigate("/login")}
            >
                {t('Administration.LoginButton')}
            </Button>

            {/* --- Cross-compatibility info --- */}
            <Grid container justifyContent="center" sx={{ marginTop: "3rem" }}>
                <Box sx={{ maxWidth: '600px', width: '100%' }}>
                    <Alert severity="info">
                        {t('Administration.CrossCompatibilityInfo')}
                    </Alert>
                </Box>
            </Grid>
        </Box>
    );
}
export default AccountCreated;
